import KunLoading47 from './src/index'

KunLoading47.install = function (Vue) {
	Vue.component(KunLoading47.name, KunLoading47);
}

export default KunLoading47;
